import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { id: "home", label: "Home", icon: "🏠", path: "/" },
    { id: "myplan", label: "My Plan", icon: "📦", path: "/myplan" },
    { id: "profile", label: "Profile", icon: "👤", path: "/profile" },
    { id: "settings", label: "Settings", icon: "⚙️", path: "/settings" }
  ];

  const currentPath = location.pathname;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50">
      <div className="flex justify-around items-center py-2 px-4 max-w-md mx-auto">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center py-2 px-3 rounded-lg transition-all duration-200 ${
              currentPath === item.path
                ? "text-green-600 bg-green-50"
                : "text-gray-600 hover:text-green-600 hover:bg-gray-50"
            }`}
          >
            <span className="text-lg mb-1">{item.icon}</span>
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav; 